// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M11.3 11.3C12.2 10.4 12.75 9.16 12.75 7.79C12.75 5.05 10.53 2.83 7.79 2.83C5.05 2.83 2.83 5.05 2.83 7.79C2.83 10.53 5.05 12.76 7.79 12.76C9.16 12.76 10.4 12.2 11.3 11.3ZM11.3 11.3L13.17 13.17',
];
